export default [
	{
		id: '1',
		name: 'simple',
	},
	{
		id: '2',
		name: 'paquete',
	},
	{
		id: '3',
		name: ' producto inversión',
	},
	{
		id: '4',
		name: 'seguro',
	},
	{
		id: '5',
		name: 'externo',
	},
	{
		id: '6',
		name: 'pensiones',
	},
];
